/* global femcare, dataLayer */

/*
 |--------------------------------------------------------------------------
 | Google analytics events.
 |--------------------------------------------------------------------------
 |
 | Event listeners to push Google analytics events.
 |
 */

/*
 * General events
 **/

femcare.tracking.gaTracking = {
    init: function () {
        var isErrorPage = $("meta[name='keywords']").attr('content') === 'error';

        // Select language interaction 
        $('.navigation-bar__language-popout a').on('click', function () {
            var selectedLanguage = $(this).data('language');

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'languageSelector',
                    eventCategory: 'Navigation',
                    eventAction: 'Language Selector',
                    eventLabel: selectedLanguage
                });
            }
        });

        // Social share interaction 
        $('.share-button').on('click', function (e) {
            e.preventDefault();
            var channel = $(this).data('channel');

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: ' socialInteraction',
                    eventCategory: 'Social Share',
                    eventAction: channel,
                    eventLabel: window.location.href
                });
            }
        });

        if (isErrorPage) {
            $(document).trigger('ga-pageError');
        }

        $('a[data-ga-title]').on('click', function (e) {
            var $link = $(this);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'gaEvent',
                eventTrigger: 'articleClick',
                eventCategory: 'Article Click',
                eventAction: $link.attr('data-ga-title'),
                eventLabel: window.location.href,
                eventValue: undefined
            });
        });
    },

    formSubmit: function ($form) {
        var eventLabel = $form.attr('data-ga-name');
        var eventTrigger = $form.attr('data-ga-trigger');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gaEvent',
            eventTrigger: eventTrigger || 'formSubmit',
            eventCategory: 'Form',
            eventAction: 'Submit',
            eventLabel: eventLabel || undefined,
            eventValue: undefined
        });
    }
};

/*
 * Azure sign up verification sent
 **/
$(document).on('ga-userSignUpVerificationSent', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userSignUpVerificationSent'
            // 'eventLabel': 'Method'
        });
    }
});

/*
 * Azure sign up verification successful
 **/
$(document).on('ga-userSignUpVerificationSuccessful', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userSignUpVerificationSuccessful'
            // 'eventLabel': 'Method'
        });
    }
});

/*
 * Azure sign up verification failed
 **/
$(document).on('ga-userSignUpVerificationFailure', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userSignUpVerificationFailure'
            // 'eventLabel': 'Method'
        });
    }
});

/*
 * Azure sign up cancel
 **/
$(document).on('ga-userSignUpCancel', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userSignUpCancel'
            // 'eventLabel': 'Method'
        });
    }
});

/*
 * Azure  sign up started
 **/
$(document).on('ga-userSignUpStarted', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userSignUpStarted',
            eventLabel: 'Azure'
        });
    }
});

/*
 * Azure facebook sign up started
 **/
$(document).on('ga-userSignUpStartedFacebook', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userSignUpStarted',
            eventLabel: 'Facebook'
        });
    }
});

/*
 * Azure sign in failure
 **/
$(document).on('ga-userLogInFailure', function (event, errorMessage) {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'userLogInFailure',
            eventLabel: errorMessage
        });
    }
});

/**
 * Page errors
 */
$(document).on('ga-pageError', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'pageError',
            eventCategory: 'Page Error',
            eventAction: 'Error 404',
            eventLabel: document.referrer
        });
    }
});
